import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('deedPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectEmailAttendeesOverlayVisible = createSelector(selectState, (state) =>
  state.get('emailAttendeesOverlayVisible')
);

export const selectAddAttendeesOverlayVisible = createSelector(selectState, (state) =>
  state.get('addAttendeesOverlayVisible')
);

export const selectInviteAttendeesOverlayVisible = createSelector(selectState, (state) =>
  state.get('inviteAttendeesOverlayVisible')
);

export const selectFormResponsesOverlayUserId = createSelector(selectState, (state) =>
  state.get('formResponsesOverlayUserId')
);

export const selectFormAggregationsOverlayVisible = createSelector(selectState, (state) =>
  state.get('formAggregationsOverlayVisible')
);

export const selectError = createSelector(selectState, (state) => state.get('error'));

export const selectVolunteerTimeResponding = createSelector(selectState, (state) =>
  state.get('volunteerTimeResponding')
);

export const selectOptInStatusLoading = createSelector(selectState, (state) =>
  state.get('setOptInStatusLoading')
);

export const selectOptInStatusError = createSelector(selectState, (state) =>
  state.get('setOptInStatusError')
);
